<template>
	<li :class='classes'>
		<a v-if="isParent" @click="toggleActive">{{item.title}}</a>
		<a v-else @click="goToRoute">{{item.title}}</a>
		<ul v-if="isParent" :style="isActive ? 'display: block;' : ''">
			<side-bar-item v-for="subItem in item.children" :key="randomId(subItem)" :item="subItem" @inactiveBrothersItems="inactiveBrothersItems" @activeParentItem="activeParentItem"/>
		</ul>
	</li>
</template>

<script>
export default {
	props: ['item'],
	/*created () {
		this.checkRoute();
	},*/
	computed: {
		isParent () {
			if (this.item.children) return true;
			else return false;
		},
		isActive () {
			return this.item.isActive;
		},
		classes () {
			let classes = [];
			if (this.isParent) classes.push('has-sub');
			if (this.isActive) classes.push('open');
			if (this.isActive && this.isParent) classes.push('openPath');
			if (this.currentRoute == this.item.route || this.currentRoute.includes(this.item.secondRoute)) classes.push('open');
			if (this.currentRoute == this.item.route && this.item.title == 'Todas') classes.push('cat0');
			if (this.currentRoute == this.item.route && this.item.title == 'Ambiente emocional') classes.push('cat1');
			if (this.currentRoute == this.item.route && this.item.title == 'Proceso académico') classes.push('cat2');
			if (this.currentRoute == this.item.route && this.item.title == 'Aprendizaje profundo') classes.push('cat3');
			if (this.currentRoute == this.item.route && this.item.title == 'Aprendizaje experto') classes.push('cat4');
			if (this.item.extraClass) classes.push(this.item.extraClass);
			return classes;
		},
		currentRoute () {
			return this.$route.fullPath;
		}
	},
	methods: {
		goToRoute () {
			if (this.$store.state.ui.showingSideMenu) this.$store.dispatch('toggleMenu');
			this.$emit('inactiveBrothersItems');
			this.$router.push(this.item.route);
		},
		toggleActive () {
			if (this.item.title == 'Resumen General' && !this.item.isActive) {
				this.$emit('inactiveBrothersItems');
				this.item.isActive = !this.item.isActive;
				this.item.children.forEach((item) => {
					item.isActive = false;
				});
				this.item.children[0].isActive = true;
				this.$router.push('/coaching/school/summary');
				return;
			}
			if (this.item.isActive) {
				this.$emit('inactiveBrothersItems');
				if (this.item.route) this.$router.push(this.item.route);
				return;
			}
			this.$emit('inactiveBrothersItems');
			if (!this.item.route) this.item.isActive = !this.item.isActive;
			if (this.item.route) this.$router.push(this.item.route);
		},
		inactiveBrothersItems () {
			this.item.children.forEach((item) => {
				item.isActive = false;
			});
		},
		activeParentItem () {
			this.item.isActive = true;
			this.$emit('activeParentItem');
		},
		randomId (item) {
			return `${item.title}-${Math.random().toString(36).substring(7)}`;
		},
		checkRoute () {
			if (this.currentRoute == this.item.route) this.$emit('activeParentItem');
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/ui/SideBarItem.vue